import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../../application/config/config';
import { getUserSession } from "../../../../core/util/core/Session"
import { loadData } from '../../../../core/components/core/Util/List/CustomList/loadData';

function List() {
    const session = getUserSession()

    const pathFrontEnd = '/core/support/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${config.endpoints.backend}core/supportrequests/delete`,
        endpoint: config.endpoints.backend + 'core/supportrequests/getall',
    }

    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            {
                name: 'status',
                type: 'select',
                label: 'Status',
                options: [
                    {
                        label: "Chamados Abertos",
                        value: "opened"
                    },
                    {
                        label: "Todos",
                        value: "all"
                    }
                ],
                validations: {
                    required: true
                },
                columnSize: 3
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            },
            {
                name: 'reset',
                type: 'reset',
                label: 'Limpar',
                columnSize: 2
            },
        ],
        values: {
            status: "opened"
        }
    }

    const isPlatformAdmin = config.default_foreign_key.profiles.admin == session.user.application_profile_id

    let list = {
        canAdd: !isPlatformAdmin,
        canEdit: false,
        canDelete: false,
        labelTitle: 'Lista de Chamados',
        labelTitleButtonAdd: 'Novo Chamado',
        formFilters: filters,
        fieldsShowOnDelete: ['title'],
        showPrintButtons: true,
        filter: {
            core_application_instance_id: session.user.application_instance_id,
            application_profile_id: session.user.application_profile_id,
            core_user_id: session.user.id
        },
        columns: [
            {
                name: 'counter',
                label: 'ID',
                width: '10%'
            },
            {
                name: 'core_status_name',
                label: 'Status'
            },
            {
                name: "created_at",
                label: "Data",
                width: '20%'
            },
            {
                name: 'title',
                label: 'Título'
            }
        ],
        ...paths
    };


    return (
        <div>
            <CustomListContainer
                canAdd={list.canAdd}
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={list} />}
            />
        </div>
    );
}
export default List;
